/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     FileDLView (was PdfView)
//   Details:    FileDLView (was PdfView) compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101877 27/06/19 JC  M01  Changed to FileDLView
// 102715 16/08/19 JC  M02  Fix to itemType propTypes
// 103782 15/12/19 JC  M03  Expanded for training
// 105066 06/01/20 JC  M04  Added font awesome
// 105750 17/01/20 JC  M05  M03 broke employee pay record retrieval
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { itemTypes } from '../constants/ItemTypes';
//M04 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M04
import './css/Item.css';

class FileDLView extends Component {
    constructor(props) {
        super(props);

        // attach handlers for item & button clicks
        this.handleStartTrainingClick = this.handleStartTrainingClick.bind(this); //M03
    }
    
    //M03 handler for start training
    handleStartTrainingClick = event => {
        event.preventDefault();
        //get the item
        const { item } = this.props;

        //pass to start training function for item
        if (this.props.startTraining) {
            this.props.startTraining(item);
        }
    }

	render() {
        const { item, itemType, startTraining, isAnsweringTraining } = this.props;
		const user = JSON.parse(localStorage.getItem('user'));
		const ticket = user.ticket;
        var action = "filedl/employeedocument"; //M03 default to employee document, then override as required
        if (itemType === itemTypes.payRecord) { action = "filedl/employeepayrecord"; } //M03 M05 was incorrectly employeedocument
        if (itemType === itemTypes.training) { action = "filedl/employeetraining"; } //M03

        return (
            <div>
                <form method="post" action={action} target="_blank">
                    <input type="hidden" name="id" value={item.id} /> {/* M03 was id */}
				    <input type="hidden" name="ticket" value={ticket} />
                    <button type="submit" className="btn btn-default"
                    ><FontAwesomeIcon icon="file" /> Open File</button> {/* M04 */}

                    {item.itemType === itemTypes.training && !item.isCompleted && !isAnsweringTraining && startTraining
                        /* M03 if training, not completed and not answering training, show start training button*/
                        ? <button className="btn btn-default btn-dftleftpadding" onClick={this.handleStartTrainingClick}><FontAwesomeIcon icon="graduation-cap" /> Q&A</button> /* M04 */
                    : []}
            
                </form>   
                               
             </div>
		);
	}
}

FileDLView.propTypes = {
    //M03 id: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired, //M03
	//M02 itemType: PropTypes.oneOf(['documentType', 'payRecordType'])
    itemType: PropTypes.oneOf([itemTypes.document, itemTypes.payRecord, itemTypes.training]), //M02 M03
    startTraining: PropTypes.func, //M03
    isAnsweringTraining: PropTypes.bool //M03
}; //M01

export default connect()(FileDLView); //M01
